// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ji-0";
export var discountCodeInput = "_ji-1";